import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import InputData from "./InputData";
import ButtonIconH from "./ButtonIconH";
import PopupMessage from "./PopupMessage";
import ActionPopup from "../components/ActionPopup";
import {
  areObjectsEqual,
  crmChannelOptions,
  selectedOptic,
  userData,
} from "../js/utils";
import { useCRMTemplates } from "../hooks/useCRMTemplates";
import { useEffect, useState } from "react";
import { post } from "../js/post";
import { AutoSendPatients } from "./AutoSendPatients";

export function AutoSendCard({ category, data, onCloseASPatients }) {
  const [actionPopup, setActionPopup] = useState(false);
  const [actionComponent, setActionComponent] = useState(null);
  const [popupQuestion, setPopupQuestion] = useState(null);
  const [currentAutoSend, setCurrentAutoSend] = useState(data);
  const [currentAutoSendFixed, setCurrentAutoSendFixed] = useState(data);
  const [toggleOp1, setToggleOp1] = useState(true);
  const [toggleOp2, setToggleOp2] = useState(false);
  const { list: templatesList, refresh: refreshTemplates } = useCRMTemplates(
    currentAutoSend.canal,
  );

  // console.log("currentAutoSend: ", currentAutoSend);

  function getCategoryName(category) {
    const categories = {
      0: "Cumpleaños",
      1: "Citas",
      2: "Revisiones de optometría",
      3: "Revisiones de lentes de contacto",
      4: "Revisiones de audiometría",
      5: "Comunicación tras venta",
      6: "Comunicación tras venta de gafas",
      7: "Comunicación tras venta de lentes de contacto",
      8: "Comunicación tras venta de audífono",
    };

    return categories[category] || "";
  }

  function getCategoryType(category) {
    const categories = {
      0: "Cumpleanos",
      1: "RecordatorioCitas",
      2: "RevisionesOptometria",
      3: "RevisionesLC",
      4: "RevisionesAudiometria",
      5: "ComunicacionTrasVenta",
      6: "ComunicacionTrasVentaGafas",
      7: "ComunicadoTrasVentaLC",
      8: "ComunicadoTrasVentaAudifono",
    };

    return categories[category] || "";
  }

  async function saveAutosend() {
    const response = await post("support-extra/crm/GuardarAutosend.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      categoriaAutosend: getCategoryType(category),
      idPlantilla: currentAutoSend.idPlantilla,
      automatizar: currentAutoSend.automatizar,
      horaEnvio: currentAutoSend.horaEnvio,
      canal: currentAutoSend.canal,
      tipoAviso: currentAutoSend.tipoAviso,
    });
    // console.log(
      // "GUARDANDO AUTOSEND: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // categoriaAutosend: getCategoryType(category),
        // idPlantilla: currentAutoSend.idPlantilla,
        // automatizar: currentAutoSend.automatizar,
        // horaEnvio: currentAutoSend.horaEnvio,
        // canal: currentAutoSend.canal,
        // tipoAviso: currentAutoSend.tipoAviso,
      // },
      // response,
    // );
  }

  async function updateTotal() {
    const response = await post(
      "support-extra/crm/ObtenerNumPacientesAutosend.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        categoriaAutosend: getCategoryType(category),
        canal: currentAutoSend.canal,
        tipoAviso: currentAutoSend.tipoAviso,
      },
    );
    // console.log(
      // "ACTUALIZANDO TOTAL: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // categoriaAutosend: getCategoryType(category),
        // canal: currentAutoSend.canal,
        // tipoAviso: currentAutoSend.tipoAviso,
      // },
      // response,
    // );
    setCurrentAutoSend((prev) => ({
      ...prev,
      total: response.total,
    }));
    setCurrentAutoSendFixed((prev) => ({
      ...prev,
      total: response.total,
    }));
  }

  const createPopupQuestion = (
    text,
    onClickAccept,
    onClickCancel,
    textAccept,
    textCancel,
  ) => {
    setPopupQuestion({
      text,
      onClickCancel,
      onClickAccept,
      textAccept,
      textCancel,
    });
  };

  const removePopupQuestion = () => {
    setPopupQuestion(null);
  };

  const handleOpenActionPopup = () => {
    setActionComponent({
      name: `Envíos para ${getCategoryName(category)}`,
      component: (
        <AutoSendPatients
          auto={currentAutoSend.automatizar}
          category={getCategoryType(category)}
          total={currentAutoSend.total}
          channel={currentAutoSend.canal}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onSend={onCloseASPatients}
        />
      ),
    });
    setActionPopup(true);
  };

  useEffect(() => {
    setCurrentAutoSend(data);
    setCurrentAutoSendFixed(data);
    setToggleOp1(data.tipoAviso === 0);
    setToggleOp2(data.tipoAviso > 0);
  }, [data]);

  useEffect(() => {
    refreshTemplates();
  }, [currentAutoSend.canal, data.canal]);

  useEffect(() => {
    setCurrentAutoSend((prev) => ({
      ...prev,
      tipoAviso: toggleOp1 ? 0 : prev.tipoAviso,
    }));
  }, [toggleOp1]);

  useEffect(() => {
    updateTotal();
  }, [currentAutoSend.canal, currentAutoSend.tipoAviso]);

  return (
    <div className="autosend-container container-panel">
      {actionPopup && (
        <ActionPopup
          name={actionComponent.name}
          children={actionComponent.component}
          overflowStyle={false}
          customClass="background-crm"
          fullscreen={actionComponent.name === "Estadísticas de campaña"}
          onClose={async () => {
            setActionPopup(false);
            setActionComponent(null);
          }}
        ></ActionPopup>
      )}
      {popupQuestion && (
        <PopupMessage
          text={popupQuestion.text}
          onClickCancel={popupQuestion.onClickCancel}
          onClickAccept={popupQuestion.onClickAccept}
          textAccept={popupQuestion.textAccept}
          textCancel={popupQuestion.textCancel}
        ></PopupMessage>
      )}
      <div className="opt-table-title">{getCategoryName(category)}</div>
      <div className="opt-table-content grid-7" id="autosend-grid">
        <div className="cell cell-label cell-start-content combined-cells-6">
          {getCategoryName(category)} del día
        </div>
        <div className="cell cell-end-content">
          <div className="autosend-total">{currentAutoSend.total}</div>
        </div>
        <div className="cell cell-label cell-start-content">Automatizar</div>
        <div className="cell cell-start-content combined-cells-2">
          <CheckBox
            tabIndex={-1}
            active={currentAutoSend.automatizar}
            onClick={() => {
              setCurrentAutoSend((prev) => ({
                ...prev,
                automatizar: !prev.automatizar,
              }));
            }}
          ></CheckBox>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Hora de envío</div>
        <div className="cell combined-cells-2 cell-start-content">
          <input
            type="time"
            step={2}
            disabled={!currentAutoSend.automatizar}
            className="input-field"
            tabIndex={-1}
            value={currentAutoSend.horaEnvio}
            onChange={(e) => {
              setCurrentAutoSend((prev) => ({
                ...prev,
                horaEnvio: e.target.value,
              }));
            }}
          />
        </div>
        <div className="cell cell-label cell-start-content combined-cells-3">
          Canal{" "}
          <Dropdown
            tabIndex={-1}
            optionList={crmChannelOptions}
            size={0}
            op={currentAutoSend.canal}
            onChange={(e) => {
              setCurrentAutoSend((prev) => ({
                ...prev,
                canal: e.id,
                idPlantilla: "",
                nombrePlantilla: "",
              }));
            }}
          ></Dropdown>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Plantilla</div>
        <div className="cell combined-cells-2">
          <Dropdown
            tabIndex={-1}
            optionList={templatesList.map((e) => ({
              id: e.idPlantilla,
              text: e.nombrePlantilla,
            }))}
            size={0}
            op={currentAutoSend.nombrePlantilla}
            onChange={(e) => {
              setCurrentAutoSend((prev) => ({
                ...prev,
                idPlantilla: e.id,
                nombrePlantilla: e.text,
              }));
            }}
          ></Dropdown>
        </div>
        <div className="cell cell-label cell-start-content combined-cells-3">
          <CheckBox
            tabIndex={-1}
            active={toggleOp1}
            onClick={() => {
              setToggleOp1((prev) => !prev);
              setToggleOp2((prev) => !prev);
            }}
          ></CheckBox>
          {category <= 4 ? "Avisar el mismo día" : "Avisar al instante"}
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content combined-cells-3">
          <CheckBox
            tabIndex={-1}
            active={toggleOp2}
            onClick={() => {
              setToggleOp2((prev) => !prev);
              setToggleOp1((prev) => !prev);
            }}
          ></CheckBox>
          {category <= 4 ? "Avisar con " : "Con posterioridad a "}
          <InputData
            tabIndex={-1}
            type="type-positive-nonzero"
            size={4}
            inactive={!toggleOp2}
            input={
              currentAutoSend.tipoAviso === 0 ? "" : currentAutoSend.tipoAviso
            }
            onChange={(e) => {
              setCurrentAutoSend((prev) => ({
                ...prev,
                tipoAviso: e,
              }));
            }}
          ></InputData>
          {category <= 4 ? " días de antelación" : " días"}
        </div>
        <div
          className="cell cell-start-content dashboard-section-or-title"
          style={{ fontSize: 14 }}
        >
          {new Date(currentAutoSend.fechaUltimoEnvio).toDateString() ===
            new Date().toDateString() && (
            <>
              <img className="cellIcon" src="images/check-orange.svg"></img>
              Enviado
            </>
          )}
        </div>
        <div
          className="cell combined-cells-6 cell-end-content"
          style={{ marginTop: 10 }}
        >
          <ButtonIconH
            text="Guardar"
            small={true}
            onClick={async () => {
              if (
                toggleOp2 &&
                (currentAutoSend.tipoAviso === 0 ||
                  currentAutoSend.tipoAviso === "")
              ) {
                createPopupQuestion(
                  "Debe añadir los días para el aviso.",
                  async () => {
                    removePopupQuestion();
                  },
                  null,
                  "Entendido",
                );
              } else if (
                currentAutoSend.idPlantilla === "" ||
                currentAutoSend.nombrePlantilla === ""
              ) {
                createPopupQuestion(
                  "Debe asociar una plantilla.",
                  async () => {
                    removePopupQuestion();
                  },
                  null,
                  "Entendido",
                );
              } else {
                await saveAutosend();
                createPopupQuestion(
                  "AutoSend guardado correctamente.",
                  async () => {
                    setCurrentAutoSendFixed(currentAutoSend);
                    removePopupQuestion();
                  },
                  null,
                  "Entendido",
                );
              }
            }}
          ></ButtonIconH>
          <ButtonIconH
            text="Envíos"
            small={true}
            disabled={currentAutoSend.total === 0}
            onClick={() => {
              if (!areObjectsEqual(currentAutoSend, currentAutoSendFixed)) {
                createPopupQuestion(
                  "Es necesario guardar los cambios realizados antes de abrir los envíos.",
                  async () => {
                    removePopupQuestion();
                  },
                  null,
                  "Entendido",
                );
              } else {
                handleOpenActionPopup();
              }
            }}
          ></ButtonIconH>
          <ButtonIconH
            text="Exportar"
            small={true}
            onClick={async () => {}}
          ></ButtonIconH>
        </div>
      </div>
    </div>
  );
}
